<template>
  <div id="app">
    <!-- pc端 -->
    <div class="container" v-show="!flag">
      <div class="header">
        <div class="logo">
          <img class="header-logo" src="./assets/LOGO（仮）.png" alt="" />
        </div>
        <div class="header-navi">
          <a href="#slef-info" class="navi-itme">
            <img style="width: 70px;" class="navi-itme-img" src="./assets/PROFILE.png" alt="">
          </a>
          <!-- <a href="#sns" class="navi-itme">
            <img style="width: 30px;" class="navi-itme-img" src="./assets/SNS.png" alt="">
          </a> -->
          <a href="#contact" class="navi-itme">
            <img style="width: 70px;" class="navi-itme-img" src="./assets/CONTACT.png" alt="">
          </a>
        </div>
      </div>
      <div class="main">
        <section class="slef-info" id="slef-info">
          <div class="info-img">
            <img class="ousaki-img" src="./assets/ousakinew.jpg" alt="" />
          </div>
          <div class="info-mmain">
            <div class="info">
              <div class="occupation">声優</div>
              <div class="name">
                <div class="name-left">{{userinfo.blogger}}</div>
                <div class="name-right">Chiyo Ousaki</div>
              </div>
              <div class="info-item" v-for="(item, index) in info" :key="index">
                <div class="info-left">{{ index }}</div>
                <div class="info-line">|</div>
                <div class="info-right">{{ item }}</div>
              </div>
            </div>
            <div class="info-logo-out">
              <a class="info-logo-box" href="https://twitter.com/ousakichiyo">
                <img class="info-logo" src="./assets/twitter.png" alt="" />
              </a>
              <a class="info-logo-box" href="https://www.instagram.com/ousakichiyo/">
                <img class="info-logo" src="./assets/instgram.png" alt="" />
              </a>
              <a class="info-logo-box" href="https://www.youtube.com/channel/UCynBu4jMSaOLQ8OSQMowP1g" style="width: 50px">
                <img class="info-logo" src="./assets/youtube.png" alt="" />
              </a>
              <a class="info-logo-box" href="https://m.twitch.tv/chiyoousaki">
                <img class="info-logo" src="./assets/twitch.png" alt="" />
              </a>
            </div>
          </div>
         
        </section>
        <section class="works">
          <div class="title">{{title.works}}</div>
          <div class="works-content">
            <div class="works-box" v-for="(item, index) in works" :key="index">
              <div class="works-left">{{ index }}</div>
              <div class="works-right">
                <div class="works-right-txt" v-for="(items, index) in item" :key="index">
                  <div v-if="items=='换行'"><br></div>
                  <div v-else>{{ items }}</div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- <section class="sns margin-t-20" id="sns">
          <div class="title">{{title.sns}}</div>
          <div class="twitter-box">
            <a class="twitter-timeline" href="https://twitter.com/ousakichiyo?ref_src=twsrc%5Etfw">Tweets by ousakichiyo</a>
          </div>
        </section> -->
        <section class="contact margin-t-20" id="contact">
          <div class="title">{{ title.contact }}</div>
          <div class="contact-content">
            <div class="contact-txt">
              出演のご依頼•お問い合わせにつきましては、フォームに必要事項をご記入の上、お問い合わせください。
            </div>
            <div class="contact-txt">
              内容を確認し、担当者よりお電話及びメールにてご連絡いたします。
            </div>
            <div class="contact-txt contact-darkred">
              個人利用目的のご依頼ご相談にはお返事いたしかねますので、改めてご了承ください。
            </div>
            <div class="contact-txt margin-t-20">
              ファンレター送付先
            </div>
            <div class="contact-txt">
              〒171-0022
            </div>
            <div class="contact-txt">
              東京都豊島区南池袋3-13-9-306  桜咲千依宛
            </div>
            <div class="contact-txt contact-darkred">
              ※食品・生もの・生き物・現金・高価なものなど一部のプレゼントの受取は、
            </div>
            <div class="contact-txt contact-darkred">
              お断りさせて頂いております。予めご了承ください。
            </div>
            <div class="contact-txt contact-shallowred margin-t-40">
              ※マークの付いているものは必須項目です。
            </div>
            <form action="">
              <div class="form-item">
                <label class="form-item-left"
                  >お名前<span class="contact-shallowred">※</span></label
                >
                <input v-model="userinfo.first_name" class="form-item-right" type="text" name="name" required="required" />
              </div>
              <div class="form-item">
                <label class="form-item-left"
                  >お名前(フリガナ)<span class="contact-shallowred">※</span></label
                >
                <input v-model="userinfo.last_name" class="form-item-right" type="text" name="name" required="required"/>
              </div>
              <div class="form-item">
                <label class="form-item-left"
                  >企業名</label
                >
                <input v-model="userinfo.enterprise_name" class="form-item-right" type="text" name="name" />
              </div>
              <div class="form-item">
                <label class="form-item-left"
                  >企業名(フリガナ)</label
                >
                <input v-model="userinfo.enterprise_name_two" class="form-item-right" type="text" name="name" />
              </div>
              <div class="form-item">
                <label class="form-item-left"
                  >電話番号(携帯番号)</label
                >
                <input v-model="userinfo.phone_number" class="form-item-right" type="text" name="name" />
              </div>
              <div class="form-item">
                <label class="form-item-left"
                  >メールアドレス<span class="contact-shallowred">※</span></label
                >
                <input v-model="userinfo.email" class="form-item-right" type="text" name="name" required="required" />
              </div>
              <div class="form-item">
                <label class="form-item-left"
                  >メールアドレス(確認)<span class="contact-shallowred">※</span></label
                >
                <input v-model="userinfo.email_confirm" class="form-item-right" type="text" name="name" required="required" />
              </div>
              <div class="form-item">
                <label class="form-item-left"
                  >お問合せ内容<span class="contact-shallowred">※</span
                  ><br />(具体的にご記入ください)</label
                >
                <textarea
                  v-model="userinfo.content"
                  class="form-item-right textarea"
                  name="name" required="required"
                ></textarea>
              </div>
              <div class="form-item" @click="submitInfo()">
                <div class="form-submit">送信</div>
              </div>
            </form>
            <div class="contact-tips">
              <div class="contact-tips-item" v-for="(item,index) in tips" :key="index">
                {{ item }}
              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="footer">
        <div v-for="(item,index) in footer" :key="index">
          {{ item }}
        </div>
      </div>
    </div>
     <!-- 移动端 -->
     <div class="m-container" v-show="flag">
      <div class="m-header">
        <div class="m-logo">
          <img class="m-header-logo" src="./assets/LOGO（仮）.png" alt="">
        </div>
      </div>
      <div class="m-main">
        <section class="m-self-info">
          <div class="m-info-top">
            <div class="m-info-topL">
              <img class="m-info-topL-img" src="./assets/ousakinew.jpg" alt="">
            </div>
            <div class="m-info-topR">
              <div>声優</div>
              <div class="m-name">{{ this.userinfo.blogger }}</div>
              <div>Chiyo Ousaki</div>
              <div></div>
            </div>
          </div>
          <div class="m-info-bottom">
            <div class="m-info-b-item" v-for="(item, index) in info" :key="index">
              <div class="m-info-left">{{ index }}</div>
              <div class="m-info-line">|</div>
              <div class="m-info-right">{{ item }}</div>
            </div>
          </div>
          <div class="m-info-logo">
              <a class="m-info-logo-box" href="https://twitter.com/ousakichiyo">
                <img class="m-info-logo" src="./assets/twitter.png" alt="" />
              </a>
              <a class="m-info-logo-box" href="https://www.instagram.com/ousakichiyo/">
                <img class="m-info-logo" src="./assets/instgram.png" alt="" />
              </a>
              <a class="m-info-logo-box" href="https://www.youtube.com/channel/UCynBu4jMSaOLQ8OSQMowP1g" style="width: 2.7778rem">
                <img class="m-info-logo" src="./assets/youtube.png" alt="" />
              </a>
              <a class="m-info-logo-box" href="https://m.twitch.tv/chiyoousaki">
                <img class="m-info-logo" src="./assets/twitch.png" alt="" />
              </a>
          </div>
        </section>
        <section class="m-works m-section-t">
          <div class="m-title">
            {{ title.works }}
          </div>
          <div class="m-work-content">
            <div class="m-content-box" v-for="(item, index) in works" :key="index">
              <div class="m-content-top">{{index}}</div>
              <div class="m-c-bottom-box">
                <div class="m-content-bottom" v-for="(items, index) in item" :key="index">
                  <div class="m-c-bottom-txt">
                    <div v-if="items=='换行'"><br></div>
                  <div v-else>{{ items }}</div>
                </div>
                </div>
              </div>
            </div>
          </div>          
        </section>
        <!-- <section class="m-sns m-section-t">
          <div class="m-title">
            {{ title.sns }}
          </div>
          <div class="twitter-box">
            <a class="twitter-timeline" href="https://twitter.com/ousakichiyo?ref_src=twsrc%5Etfw">Tweets by ousakichiyo</a>
          </div>
        </section> -->
        <section class="contact m-section-t">
          <div class="m-title">
            {{ title.contact }}
          </div>
          <div class="m-contact-content">
            <div class="m-contact-txt">
              出演のご依頼•お問い合わせにつきましては、フォームに必要事項をご記入の上、お問い合わせください。
            </div>
            <div class="m-contact-txt">
              内容を確認し、担当者よりお電話及びメールにてご連絡いたします。
            </div>
            <div class="m-contact-txt m-contact-darkred">
              個人利用目的のご依頼ご相談にはお返事いたしかねますので、改めてご了承ください。
            </div>
            <div class="m-contact-txt m-margin-t-20">
              ファンレター送付先
            </div>
            <div class="m-contact-txt">
              〒171-0022
            </div>
            <div class="m-contact-txt">
              東京都豊島区南池袋3-13-9-306  桜咲千依宛
            </div>
            <div class="m-contact-txt m-contact-darkred">
              ※食品・生もの・生き物・現金・高価なものなど一部のプレゼントの受取は、
            </div>
            <div class="m-contact-txt m-contact-darkred">
              お断りさせて頂いております。予めご了承ください。
            </div>
            <div class="m-contact-txt m-contact-shallowred m-margin-t-40">
              ※マークの付いているものは必須項目です。
            </div>
            <form action="">
              <div class="m-form-item">
                <label class="m-form-item-left"
                  >お名前<span class="m-contact-shallowred">※</span></label
                >
                <input v-model="userinfo.first_name" class="m-form-item-right" type="text" name="name" required="required" />
              </div>
              <div class="m-form-item">
                <label class="m-form-item-left"
                  >お名前(フリガナ)<span class="m-contact-shallowred">※</span></label
                >
                <input v-model="userinfo.last_name" class="m-form-item-right" type="text" name="name" required="required"/>
              </div>
              <div class="m-form-item">
                <label class="m-form-item-left"
                  >企業名</label
                >
                <input v-model="userinfo.enterprise_name" class="m-form-item-right" type="text" name="name" />
              </div>
              <div class="m-form-item">
                <label class="m-form-item-left"
                  >企業名(フリガナ)</label
                >
                <input v-model="userinfo.enterprise_name_two" class="m-form-item-right" type="text" name="name" />
              </div>
              <div class="m-form-item">
                <label class="m-form-item-left"
                  >電話番号(携帯番号)</label
                >
                <input v-model="userinfo.phone_number" class="m-form-item-right" type="text" name="name" />
              </div>
              <div class="m-form-item">
                <label class="m-form-item-left"
                  >メールアドレス<span class="m-contact-shallowred">※</span></label
                >
                <input v-model="userinfo.email" class="m-form-item-right" type="text" name="name" required="required" />
              </div>
              <div class="m-form-item">
                <label class="m-form-item-left"
                  >メールアドレス(確認)<span class="m-contact-shallowred">※</span></label
                >
                <input v-model="userinfo.email_confirm" class="m-form-item-right" type="text" name="name" required="required" />
              </div>
              <div class="m-form-item">
                <label class="m-form-item-left"
                  >お問合せ内容<span class="m-contact-shallowred">※</span
                  ><br />(具体的にご記入ください)</label
                >
                <textarea
                  v-model="userinfo.content"
                  class="m-form-item-right m-textarea"
                  name="name" required="required"
                ></textarea>
              </div>
              <div class="m-form-item" @click="submitInfo()">
                <div class="m-form-submit">送信</div>
              </div>
            </form>
            <div class="m-contact-tips">
              <div class="m-contact-tips-item" v-for="(item,index) in tips" :key="index">
                {{ item }}
              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="m-footer">
        <div v-for="(item,index) in footer" :key="index">
          {{ item }}
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import $ from "jquery";
export default {
  name: "App",
  data() {
    return {
      flag: true,
      showAlr:true,
      info: {
        '誕生日': "2月12日",
        '身長': "146cm",
        '出身地': "神奈川県",
        '血液型': "O型",
      },
      title:{
        works:'主な出演作品/ Works',
        sns:'SNS',
        contact:'お問い合わせ/ Contact'
      },
      footer:[
        '当サイトに掲載されているすべての内容（画像・音声・文章等）の 無断での使用・転載・引用を禁止します。',
        '©CAT222'
      ],
      works: {
        '【New】': ["SNS発見アドベンチャー～ふぉろみ＆ただみ～ (ナレーション)","ねまちょ～今日もどこかのまんなかで～(番組)"],
        '【アニメ】': [
          "D.C.III 〜ダ・カーポIII〜（瑠川さら）",
          "アイドルマスター シンデレラガールズ（白坂小梅）",
          "ワガママハイスペック（宮瀬未尋）",
          "アイドルマスター シンデレラガールズ劇場（白坂小梅、あの子）",
          "邪神ちゃんドロップキック（モヒカンくん）",
          "魔王様、リトライ!（ミンク）",
          "アズールレーン（文月、長月）",
        ],
        '【ゲーム】': [
          "D.C.III 〜ダ・カーポIII〜（瑠川さら / サラ・クリサリス）",
          "アイドルマスター シンデレラガールズ（白坂小梅）",
          "アズールレーン（文月、長月）",
          "おじさまと猫 スーパーミラクルパズル（後藤もみじ）",
          "さくらいろプリズム（明石澪）",
          "アークナイツ（ポプカル）",
          "ドールズフロントライン（Ameli、SP9）",
          "ブラック・サージナイト（ライプツィヒ）",
          "セブンズストーリー（イータ、モニカ）",
          "テイマーズダンジョン〜迷宮の魔物使い〜（メリアス）",
          "葛唄-カズラウタ-（澄池早紀）",
          "1/2 summer+（テトメト）",
          "白猫プロジェクト（ロッカ・フブキ）",
          "メギド72（コルソン）",
          "はがねオーケストラ（ムラサキ、ミコト、カグラ）",
          "桜花裁き 斬（山陰阿国）",
          "サウザンドメモリーズ（カーリー）",
          "イースIX -Monstrum NOX-（アーチェ）",
          "クイズRPG 魔法使いと黒猫のウィズ（リクリン・へクス）",
          "ラストオリジン（天香のヒルメ、宝蓮、チョナ）"
        ],
        '【ラジオ・番組】': [
          "けーすけ・ちよの声優で地球は救われる!",
          "あんちょびステーション",
          "サブちゃん一家のやっぱりアニメはやめられない!？",
          "風見学園新聞部",
          "ラジオD.C.",
          "ラジオD.C.2014",
          "あらぶんちょ！",
          "五十嵐裕美・桜咲千依のあけっぴろげパーティ！"
        ],
        '【Webアニメ】': ["女子高生信長ちゃん!!（信長ちゃん / 吉乃田法子）"],
        '【舞台】': [
          "『Oji 〜ヘンテコリンなわんぱくおじさん〜』（島ねずみのチコ）",
          "『「音小増と殻少女」改め「IのMEMORIES」』（珠子）",
          "『黒子ノ譲志』（かよ子人形）",
          "『番外 池田屋・裏』（岬つくし）",
          "『闘争×ホルモン TackleBagタックルバッグ』（大浦晴江〈学生時代〉）",
          "『女女女ニョニョニョ』（たると役）",
          "朗読劇『超訳文学〜吾輩は猫である〜』（三毛子、他）",
          "超訳文学 朗読劇『夏の夜の夢』（タイターニア）",
          "THE LIVE READING『武装少女マキャヴェリズム』（因幡月夜）",
          "ミュージカル『ソーォス!』（アマンダ）",
          "换行",
          "他多数"
        ]
      },
      tips: [
        '※土・日・祝日のお問合せは、翌営業日または翌週以降（平日）のご返信になりますので、予めご了承ください。',
        '※お送りいただきました全てのメールを確認しておりますが、ご返答にお時間をいただく場合や、内容によってはご返答できかねる場合がございます。',
        '※ご意見・ご要望や、ファンメールは、個別に回答や返信は行われませんので、予めご了承ください。',
        '※タレントのプライベートに関わる質問にはお答え出来ません。',
        '※メールアドレスの記述ミスがある場合は、ご返答メールをお送りできませんので十分にご注意ください。',
      ],
      userinfo:{
        blogger:'桜咲 千依',
        first_name:'',
        last_name:'',
        enterprise_name:'',
        enterprise_name_two:'',
        phone_number:'',
        email:'',
        email_confirm:'',
        content:''
      }
    };
  },
  created(){
    window.addEventListener("load", function() {
        window.fbAsyncInit = function() {
            FB.Event.subscribe('edge.create', function(targetUrl) {
                ga('send', 'social', 'facebook', 'like', targetUrl);
            });
            FB.Event.subscribe('edge.remove', function(targetUrl) {
                ga('send', 'social', 'facebook', 'unlike', targetUrl);
            });
        }

        // document.getElementById('tweetjs').addEventListener('load', function() {
        //     twttr.ready(function (twttr) {
        //         twttr.events.bind('tweet', function(e){
        //             if(!e) return;
        //             ga('send', 'social', 'twitter', 'tweet', theURL);
        //         })
        //     });
        // }, false);
    }, false);
  },
  mounted(){
    this.scroll()
    //判断是手机还是电脑
    if((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
        this.flag = true     //手机
    } else {
        this.flag = false     //电脑
    }
    // const that = this
    // this.$nextTick(()=>{
      // let a = document.createElement('a')
      // a.href = "https://twitter.com/ousakichiyo"
      // console.log(a.href)
      // let twitterBox = document.querySelector('#m-twitter')
      // twitterBox.appendChild(a)
      // twttr.widgets.load(
        // document.getElementById("m-twitter")
        // $('#m-twitter').html('<a href="https://twitter.com/ousakichiyo" class="m-twitter"></a>')
        // twttr.widgets.createTweet(
        //   "100",
        //   document.getElementById("m-twitter"),
        //   {
        //     theme: "light",
        //     // url:'https://twitter.com/ousakichiyo' 
        //   }
        // ).then( function( el ) {
        //   console.log(el);
        //   if(el) {
        //     console.log('进来了')
        //     that.showAlr = false
        //     console.log(this.showAlr)
        //   }
        // })
      // );
    // })
  },
  methods: {
    //提交表单数据
    submitInfo() {
      if(this.userinfo.first_name =='' || this.userinfo.last_name =='' || this.userinfo.email =='' || this.userinfo.email_confirm =='' || this.userinfo.content ==''){
        alert('必須項目は空白にできません')
        return
      }
      if(this.userinfo.email != '' && this.userinfo.email_confirm != ''){
        var reg=/^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/;
        if(!reg.test(this.userinfo.email)){
          alert('メールボックスの認証に失敗しました!')
          return
        } else {
        if( this.userinfo.email != this.userinfo.email_confirm ){
          alert('2回のメールボックス入力が異なる')
          return
        }
        let forms = new FormData()
          for(var key in this.userinfo){
            forms.append(key,this.userinfo[key]);
          }
        var settings = {
          "url": "https://cat222.jp/ousaki/email.php",
          "method": "POST",
          "timeout": 0,
          "processData": false,
          "mimeType": "multipart/form-data",
          "contentType": false,
          "data": forms
        };
        $.ajax(settings).done(function (response) {
          let res = JSON.parse(response)
          if (res.code == 'SUCCESS'){
            alert("お問い合わせいただき、誠にありがとうございます。\n内容を確認したうえで、後日担当者からご連絡させていただきます。")
          } else {
            alert(res.msg)
          }
         
        });
       
        }
      }
    },
    scroll() {
      $(function () {
        //锚点的过渡效果
        $(document).on("click", 'a[href^="#"]', function () {
          if (
            location.pathname.replace(/^\//, "") ==
              this.pathname.replace(/^\//, "") &&
            location.hostname == this.hostname
          ) {
            var $target = $(this.hash);
            $target =
              ($target.length && $target) ||
              $("[name=" + this.hash.slice(1) + "]"); //获取到点击对应id的元素
            if ($target.length) {
              var targetOffset = $target.offset().top;
              $("html,body").animate(
                {
                  //滑动效果主要用到jq的animate函数
                  scrollTop: targetOffset,
                },
                500
              );
              return false;
            }
          }
        });

        //滚动条滑动到相应位置导航栏显示高亮
        function checkscroll() {
          wint = $(window).scrollTop(); //屏幕位置
          var NodePos = [
            $("#introduction").offset().top,
            $("#culture").offset().top,
          ]; //提前获取好元素位

          if (wint < NodePos[1]) {
            $(".about-tab a").removeClass("active");
            $(".about-tab a:nth-child(1)").addClass("active");
          } else if (NodePos[1] <= wint && wint < NodePos[2] - 0.5) {
            $(".about-tab a").removeClass("active");
            $(".about-tab a:nth-child(2)").addClass("active");
          }
        }
      });
    },
  },
};
</script>

<style>
#app {
}
body,
html {
  padding: 0;
  margin: 0;
  font-size: 18px;
}

/* 移动端 */
.m-container {
  width: 100vw;
  
}
.m-header {
  /* width: 15%; */
  padding:10px 0px 10px 10px;
  box-sizing: border-box;
  border-bottom: 1px solid red;
}
.m-logo {
  width: 30vw;
}
.m-header-logo{
  width: 100%;
}
.m-main {
  margin: 20px;
}
.m-self-info {

}
.m-info-top{
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
}
.m-info-topL{
  width: 100%;
}
.m-info-topL-img{
  width: 100%;
}
.m-name {
  font-size: 1.4286rem;
  margin: 6px 0;
  font-weight: bold;
}
.m-info-topR {
  width: 48%;
  font-size: 1rem;
}
.m-info-bottom {
  margin-top: 10px;
}
.m-info-left {
  text-align: justify;
  text-align-last: justify;
  width:3.3333rem;
  position: relative;
}
.m-info-left::after {
  content: "";
  display: inline-block;
  position: absolute;
  width: 100%;
}
.m-info-logo {
  display: flex;
  align-items: center;
  margin-top: .5556rem;
}
.m-info-logo-box {
  width: 2.2222rem;
  margin-right: 1.1111rem;
}
.m-info-logo {
  width: 100%;
}

.m-info-b-item {
  display: flex;
  padding: 10px 0px 10px 6px;
  border-top: 1px solid rgb(107, 105, 105);
}
.m-info-b-item:last-child {
  border-bottom: 1px solid rgb(107, 105, 105);
}
.m-info-line {
  margin: 0 20px;
}
.m-title {
  border-bottom: 1px solid rgb(107, 105, 105);
  padding-bottom: 6px;
  font-size: 1.1111rem;
}
.m-works {
}
.m-section-t{
  margin-top: 40px;
}
.m-work-content {
  font-size: 1rem;
}
.m-c-bottom-box {
  /* margin-top: 10px; */
}
.m-content-box {
  margin-top: 20px;
}
.m-content-top{
  font-size: 1rem;
  font-weight: bold;
}
.m-c-bottom-txt {
  word-wrap: break-word;
  line-height: 1.5556rem;
}
.m-twitter-box {
  padding: 20px 40px;
  height: 30vh;
  box-sizing: border-box;
  overflow-y: scroll;
}
.m-footer {
  margin: 28px;
  text-align: center;
  font-size: .8889rem; 
}
.m-contact-content {
  word-wrap: break-word;
  font-size: 1rem;
  color: rgb(46, 45, 45);
  margin-top: 20px;
}
.m-contact-txt {
}
.m-contact-darkred {
  color: #ff6969;
}
.m-contact-shallowred {
  color: #ea5415;
}
.m-margin-t-20 {
  margin-top: 20px;
}
.m-margin-t-40 {
  margin-top: 40px;
}
.m-form-item {
  display: flex;
  margin-top: .5556rem;
  display: flex;
  flex-direction: column;
}
.m-form-item-left {
  word-wrap: break-word;
}
.m-form-item-right {
  padding: .2222rem;
  box-sizing: border-box;
  margin-top:10px;
  border: 1px solid #ccc;
}
.m-textarea {
  height: 20vh;
  resize: none;
}
.m-form {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.m-form-submit {
  padding: .3333rem 4.4444rem;
  color: white;
  background-color: #ccc;
  border: none;
  margin: 0 auto;
  margin-top: 1.1111rem;
  cursor: pointer;
  margin-top: 20px;
}
.m-contact-tips {
  margin-top: 2.2222rem;
  color: #524947;
  font-size: .8889rem;
}
.m-contact-tips-item {
  margin-top: 0.2222rem;
}
.m-footer {
  margin: 2.2222rem 20px;
  text-align: center;
  font-size: 12px;
}


/* pc端 */
.container {
  width: 1080px;
  margin: 0 auto;
  margin-top: 20px;
}
.header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding-bottom: 4px;
  border-bottom: 1px solid red;
}
.logo {
  width: 200px;
}
.header-logo {
  width: 100%;
}
.header-navi {
  display: flex;
  margin-right: 120px;
}
.navi-itme {
  margin-right: 50px;
}
.navi-itme:nth-child(3){
  margin-right: 30px;
}
.main {
  width: 780px;
  margin: 0 auto;
  /* margin-top: 20px; */
}
.slef-info {
  display: flex;
  flex-direction: column;
  color: rgb(107, 105, 105);
  font-size: 14px;
}
.info-mmain {
  display: flex;
}
.info {
  margin-top: 20px;
  flex: 1;
  margin-right: 40px;
  /* margin-left: 40px;
  width: calc(100% - 240px); */
}
.occupation {
  color: #000;
}
.name {
  display: flex;
  align-items: center;
}
.name-left {
  font-size: 18px;
  color: black;
}
.name-right {
  font-size: 14px;
  margin-left: 20px;
}
.info-item {
  display: flex;
  width: 100%;

  border-top: 1px solid rgb(107, 105, 105);
  padding: 8px 0;
}
.info-left {
  width: 50px;
}
.info-line {
  padding: 0 20px;
}
.info-right {
}
.info-img {
  width: 100%;
  margin-top: 10px;
}
.ousaki-img {
  width: 100%;
}
.info-logo-out {
  display: flex;
  width: 60px;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}
.info-logo-box {
  width: 40px;
  margin-bottom: 10px;
}
.info-logo {
  width: 100%;
}
.title {
  font-size: 24px;
  border-bottom: 1px solid rgb(158, 155, 155);
}
.works {
}
.works-content {
}
.works-box {
  display: flex;
  margin-top: 20px;
  font-size: 14px;
  color: rgb(60, 60, 60);
}
.works-left {
  width: 114px;
}
.works-right {
  padding-left: 40px;
  border-left: 2px solid rgb(128, 126, 126);
}
.works-right-txt {
  word-wrap: break-word;
}
.contact-content {
  word-wrap: break-word;
  font-size: 14px;
  color: rgb(46, 45, 45);
  margin-top: 20px;
}
.contact-txt {
}
.contact-darkred {
  color: #ff6969;
}
.contact-shallowred {
  color: #ea5415;
}
.margin-t-20 {
  margin-top: 20px;
}
.margin-t-40 {
  margin-top: 40px;
}
.form-item {
  display: flex;
  margin-top: 30px;
}
.form-item-left {
  width: 200px;
  word-wrap: break-word;
}
.form-item-right {
  width: calc(100% - 220px);
  border: 1px solid #ccc;
}
.textarea {
  height: 130px;
  resize: none;
}
.form {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.form-submit {
  padding: 6px 80px;
  color: white;
  background-color: #ccc;
  border: none;
  margin: 0 auto;
  cursor: pointer;
  /* margin-top: 40px; */
}
.contact-tips {
  margin-top: 40px;
  color: #524947;
}
.footer {
  margin: 40px 0;
  text-align: center;
  font-size: 12px;
}
.twitter-box {
  margin: 20px 10%;
  height: 50vh;
  box-sizing: border-box;
  overflow-y: scroll;
}


</style>



// WEBPACK FOOTER //
// src/App.vue